import type { EmailGlobalStyles } from '../HtmlEditor.types';
import { ColorRow, Field } from './Inspector/inspectorFields';

type StyleTabProps = {
  styles: EmailGlobalStyles;
  onChange: (patch: Partial<EmailGlobalStyles>) => void;
  disabled?: boolean;
};

const FONT_OPTIONS = ['Arial', 'Helvetica', 'Georgia', 'Verdana', 'Times New Roman'];

export function StyleTab({ styles, onChange, disabled }: StyleTabProps) {
  return (
    <div className='ee-style-tab'>
      <div className='ee-insp__section'>
        <div className='ee-insp__title'>Email background</div>
        <ColorRow
          label='Background color'
          value={styles.backgroundColor}
          disabled={disabled}
          onChange={(v) => onChange({ backgroundColor: v })}
        />
        <ColorRow
          label='Content background'
          value={styles.contentBackground}
          disabled={disabled}
          onChange={(v) => onChange({ contentBackground: v })}
        />
      </div>
      <div className='ee-insp__section'>
        <div className='ee-insp__title'>Default typography</div>
        <Field label='Font family'>
          <select
            className='select'
            value={styles.fontFamily}
            disabled={disabled}
            onChange={(e) => onChange({ fontFamily: e.target.value })}
          >
            {FONT_OPTIONS.map((f) => (
              <option key={f} value={f}>
                {f}
              </option>
            ))}
          </select>
        </Field>
        <Field label='Base size'>
          <input
            className='input'
            type='number'
            value={styles.baseSize}
            disabled={disabled}
            onChange={(e) => onChange({ baseSize: +e.target.value })}
          />
        </Field>
        <ColorRow
          label='Default text color'
          value={styles.defaultTextColor}
          disabled={disabled}
          onChange={(v) => onChange({ defaultTextColor: v })}
        />
        <ColorRow
          label='Link color'
          value={styles.linkColor}
          disabled={disabled}
          onChange={(v) => onChange({ linkColor: v })}
        />
      </div>
      <div className='ee-insp__section'>
        <div className='ee-insp__title'>Layout</div>
        <Field label='Email width (px)'>
          <input
            className='input'
            type='number'
            value={styles.emailWidth}
            disabled={disabled}
            onChange={(e) => onChange({ emailWidth: +e.target.value })}
          />
        </Field>
        <Field label='Border radius'>
          <input
            className='input'
            type='number'
            value={styles.borderRadius}
            disabled={disabled}
            onChange={(e) => onChange({ borderRadius: +e.target.value })}
          />
        </Field>
      </div>
    </div>
  );
}
